import { Route, Switch} from 'react-router-dom';
import React from 'react';
import Index from './index';
import Window from './screens/Wrap';
class Routes extends React.Component{
  render() {
    return (
  		<Switch>
    		<Route path="/login" component={Index} exact />
  		</Switch>
    );
  }
}
export default Routes;